

const HitDetails = ({ hit, onBack, onBackToSummary }) => {
  return (
    <div className="mt-3">
      <h5 className="mb-4">Hit Details: {hit.name}</h5>
      <div className="card p-3">
        <div className="mb-3">
          <strong>Name:</strong> {hit.name}
        </div>
        <div className="mb-3">
          <strong>Processed Name:</strong> {hit.processedName}
        </div>
        <div>
          <strong>Violations:</strong>
          <ul className="mt-2">
            {hit.violations &&
              hit.violations.map((violation, index) => (
                <li key={index}>{violation}</li>
              ))}
          </ul>
        </div>
      </div>
      
      <div className="d-flex justify-content-center mt-3">
        <button className="btn createButton me-3" onClick={onBack}>
          Back
        </button>
        <button className="btn createButton" onClick={onBackToSummary}>
          Back to Summary
        </button>
      </div>
    </div>
  );
};

export default HitDetails;
